export const ID = '5ae7a810-5721-4f96-99a8-efa681efa9e5';

export const NAME = 'StorageMart Checkout Confirmation Storedge';
